import './Month.css';
export default {
    "month": "Month_month__20oud",
    "monthDates": "Month_monthDates__20oud"
};
